import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, Image, Alert } from 'react-native';

import { Clipboard } from 'react-native';
import api from '../services/api';

const ClienteCartela = ({ route, navigation }) => {
  const [cartelas, setCartelas] = useState([]);
  const [nome, setNome] = useState('');
  const [whatsapp, setWhatsapp] = useState('');

  useEffect(() => {
    async function load() {
      const sorteioId = route.params.sorteioId;
      const clienteId = route.params.dados.id;
      if (!sorteioId || !clienteId) return;
      const { data } = await api.get(
        `sorteios/${sorteioId}/clientes/${clienteId}`
      );
      setNome(data.cliente.nome);
      setWhatsapp(data.cliente.whatsapp);
      setCartelas(data.cartelas || []);
    }
    load();
  }, []);

  const compartilharArquivo = () => {
    const sorteioId = route.params.sorteioId;
    const clienteId = route.params.dados.id;
    const originalUrl = window.location.origin;
    Clipboard.setString(
      originalUrl + '/#/cartelas/' + sorteioId + '/' + clienteId
    );
  };

  const apagarCartela = async (cartelaId) => {
    const x = confirm('Deseja realmente apagar esta venda?');
    if (!x) return;
    const sorteioId = route.params.sorteioId;
    try {
      await api.delete(`sorteios/${sorteioId}/cancelar_venda/${cartelaId}`);
      const novasCartelas = cartelas.filter((c) => c.id !== cartelaId);
      setCartelas(novasCartelas);

      if (novasCartelas.length === 0) {
        alert('Venda apagada com sucesso! Cliente não possui mais cartelas.');
        if (route.params.onRefresh) {
          route.params.onRefresh();
        }
        navigation.goBack();
      } else {
        alert('Venda apagada com sucesso!');
      }
    } catch (e) {
      alert('Falha ao apagar a venda.');
    }
  };

  const imprimirTodasCartelas = () => {
    if (!cartelas || cartelas.length === 0) {
      Alert.alert('Atenção', 'Nenhuma cartela disponível');
      return;
    }

    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      Alert.alert('Erro', 'Por favor, permita pop-ups para imprimir');
      return;
    }

    let html = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>Cartelas - ${nome}</title>
          <style>
            @media print {
              @page {
                size: 80mm auto;
                margin: 5mm;
              }
              .cartela {
                page-break-after: always;
                page-break-inside: avoid;
              }
              .cartela:last-child {
                page-break-after: auto;
              }
            }
            body {
              margin: 0;
              padding: 10px;
              font-family: Arial, sans-serif;
            }
            .cartela {
              margin-bottom: 20px;
              text-align: center;
            }
            .header {
              margin-bottom: 15px;
            }
            .logo {
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 10px;
            }
            .info {
              margin: 10px 0;
              font-size: 14px;
            }
            .numeros {
              margin: 15px 0;
            }
            .numero {
              display: inline-block;
              margin: 5px;
              padding: 10px 20px;
              border: 2px solid #000;
              border-radius: 10px;
              font-size: 20px;
              font-weight: bold;
            }
            .cartela-id {
              margin-top: 15px;
              font-size: 12px;
            }
          </style>
        </head>
        <body>
    `;

    cartelas.forEach((cartela) => {
      html += `
          <div class="cartela">
            <div class="header">
              <div class="logo">MASTER PREMIOS</div>
              <div style="border-top: 2px solid #000; margin: 10px 0;"></div>
            </div>
            <div class="info">
              <strong>Cliente:</strong> ${nome}<br>
              <strong>WhatsApp:</strong> ${whatsapp}
            </div>
            <div class="info">
              <strong>Cartela ID:</strong> ${cartela.id}
            </div>
            <div style="border-top: 1px solid #000; margin: 15px 0;"></div>
            <div class="numeros">
      `;

      if (cartela.numeros && Array.isArray(cartela.numeros)) {
        cartela.numeros.forEach((numero) => {
          html += `<div class="numero">${numero}</div>`;
        });
      }

      html += `
            </div>
            <div style="border-top: 1px solid #000; margin: 15px 0;"></div>
            <div class="cartela-id">
              Cartela ID: ${cartela.id}
            </div>
          </div>
      `;
    });

    html += `
        </body>
      </html>
    `;

    printWindow.document.write(html);
    printWindow.document.close();

    printWindow.onload = () => {
      setTimeout(() => {
        printWindow.print();
      }, 250);
    };
  };

  return (
    <div id="paginaprint" style={{ flex: 1, width: '100%' }}>
      <View style={{ margin: 20, flex: 1 }}>
        <View style={{ alignItems: 'center' }}>
          <Image
            style={{
              height: 200,
              width: 200,
              marginTop: -50,
              marginBottom: -50,
            }}
            source={require('../assets/logo.png')}
          />
        </View>

        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
            flexDirection: 'row',
          }}
        >
          <View style={{ flex: 1 }}>
            <View>
              <Text style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Nome Cliente
              </Text>
              <Text style={{ textAlign: 'center' }}>{nome}</Text>
            </View>
          </View>
          <View style={{ flex: 1 }}>
            <View>
              <Text style={{ fontWeight: 'bold', textAlign: 'center' }}>
                Whatsapp
              </Text>
              <Text style={{ textAlign: 'center' }}>{whatsapp}</Text>
            </View>
          </View>
        </View>

        {JSON.parse(localStorage.getItem('user'))?.tipo === 'ADMIN' && (
          <View style={{ marginTop: 10 }}>
            <TouchableOpacity
              style={{ flex: 1, marginRight: 5 }}
              onPress={() => apagarCartela(e.id)}
            >
              <Text
                style={{
                  backgroundColor: '#e74c3c',
                  color: '#fff',
                  padding: 5,
                  borderRadius: 5,
                  textAlign: 'center',
                }}
              >
                Apagar
              </Text>
            </TouchableOpacity>
          </View>
        )}

        <TouchableOpacity
          onPress={() => compartilharArquivo()}
          style={{ marginTop: 10 }}
        >
          <Text
            style={{
              backgroundColor: '#1abc9c',
              color: '#fff',
              padding: 5,
              borderRadius: 5,
              textAlign: 'center',
            }}
          >
            Copiar Link
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          onPress={imprimirTodasCartelas}
          style={{ marginTop: 10 }}
        >
          <Text
            style={{
              backgroundColor: '#27ae60',
              color: '#fff',
              padding: 5,
              borderRadius: 5,
              textAlign: 'center',
            }}
          >
            Imprimir
          </Text>
        </TouchableOpacity>

        {cartelas.map((e, index) => (
          <View
            onPress={() =>
              navigation.navigate('ClientesCartelas', { dados: e })
            }
            style={{
              backgroundColor: '#fff',
              padding: 10,
              borderRadius: 5,
              flexDirection: 'row',
              marginTop: 10,
            }}
          >
            <View>
              <Image
                style={{
                  height: cartelas[0].numeros.length > 3 ? 100 : 150,
                  width: cartelas[0].numeros.length > 3 ? 100 : 150,
                }}
                source={require('../assets/logo.png')}
              />
              <Text style={{ fontSize: 9, textAlign: 'center', marginTop: 5 }}>
                {cartelas[0].id}
              </Text>
            </View>

            {cartelas[0] &&
            cartelas[0].numeros &&
            cartelas[0].numeros.length > 3 ? (
              <View style={{ flex: 1 }}>
                <View style={{ flex: 1, flexDirection: 'row' }}>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        borderWidth: 1,
                        borderColor: '#95a5a6',
                        padding: 2.5,
                        borderRadius: 10,
                        margin: 5,
                      }}
                    >
                      {cartelas[index].numeros[0]}
                    </Text>
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        borderWidth: 1,
                        borderColor: '#95a5a6',
                        padding: 2.5,
                        borderRadius: 10,
                        margin: 5,
                      }}
                    >
                      {cartelas[index].numeros[1]}
                    </Text>
                  </View>
                </View>

                <View style={{ flex: 1, flexDirection: 'row' }}>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        borderWidth: 1,
                        borderColor: '#95a5a6',
                        padding: 2.5,
                        borderRadius: 10,
                        margin: 5,
                      }}
                    >
                      {cartelas[index].numeros[2]}
                    </Text>
                  </View>
                  <View style={{ flex: 1 }}>
                    <Text
                      style={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        borderWidth: 1,
                        borderColor: '#95a5a6',
                        padding: 2.5,
                        borderRadius: 10,
                        margin: 5,
                      }}
                    >
                      {cartelas[index].numeros[3]}
                    </Text>
                  </View>
                </View>

                <View style={{ flex: 1, flexDirection: 'row' }}>
                  {cartelas[0].numeros.length > 4 && (
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontWeight: 'bold',
                          textAlign: 'center',
                          borderWidth: 1,
                          borderColor: '#95a5a6',
                          padding: 2.5,
                          borderRadius: 10,
                          margin: 5,
                        }}
                      >
                        {cartelas[index].numeros[4]}
                      </Text>
                    </View>
                  )}

                  {cartelas[0].numeros.length > 4 && (
                    <View style={{ flex: 1 }}>
                      <Text
                        style={{
                          fontWeight: 'bold',
                          textAlign: 'center',
                          borderWidth: 1,
                          borderColor: '#95a5a6',
                          padding: 2.5,
                          borderRadius: 10,
                          margin: 5,
                        }}
                      >
                        {cartelas[index].numeros[5]}
                      </Text>
                    </View>
                  )}
                </View>
              </View>
            ) : (
              <View style={{ flex: 1 }}>
                <View style={{ alignItems: 'center' }}>
                  <Text
                    style={{
                      textAlign: 'center',
                      borderWidth: 1,
                      fontSize: 18,
                      borderColor: '#95a5a6',
                      padding: 5,
                      paddingLeft: 30,
                      paddingRight: 30,
                      borderRadius: 10,
                      margin: 5,
                    }}
                  >
                    {cartelas[index].numeros[0]}
                  </Text>
                </View>

                <View style={{ alignItems: 'center', marginTop: 10 }}>
                  <Text
                    style={{
                      textAlign: 'center',
                      borderWidth: 1,
                      fontSize: 18,
                      borderColor: '#95a5a6',
                      padding: 5,
                      paddingLeft: 30,
                      paddingRight: 30,
                      borderRadius: 10,
                      margin: 5,
                    }}
                  >
                    {cartelas[index].numeros[1]}
                  </Text>
                </View>

                <View style={{ alignItems: 'center', marginTop: 10 }}>
                  <Text
                    style={{
                      textAlign: 'center',
                      borderWidth: 1,
                      fontSize: 18,
                      borderColor: '#95a5a6',
                      padding: 5,
                      paddingLeft: 30,
                      paddingRight: 30,
                      borderRadius: 10,
                      margin: 5,
                    }}
                  >
                    {cartelas[index].numeros[2]}
                  </Text>
                </View>

                {JSON.parse(localStorage.getItem('user'))?.tipo === 'ADMIN' && (
                  <View style={{ marginTop: 10 }}>
                    <TouchableOpacity
                      style={{ flex: 1, marginRight: 5 }}
                      onPress={() => apagarCartela(e.id)}
                    >
                      <Text
                        style={{
                          backgroundColor: '#e74c3c',
                          color: '#fff',
                          padding: 5,
                          borderRadius: 5,
                          textAlign: 'center',
                        }}
                      >
                        Apagar
                      </Text>
                    </TouchableOpacity>
                  </View>
                )}
              </View>
            )}
          </View>
        ))}
      </View>
    </div>
  );
};

export default ClienteCartela;
